// extracted by mini-css-extract-plugin
module.exports = {"offlineBanner":"root_offlineBanner__3Nv47","root":"root_root__2B8eW"};